import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { SERVER_API_URL } from '../../app.constants';
import { SampleList, StudySampleList } from './sample-list.model';
import { Observable } from 'rxjs';
import { createRequestOption } from '../../shared';
import { map } from 'rxjs/operators';
import { ParamContext } from '../../shared/service/param.context';

@Injectable({ providedIn: 'root' })
export class SampleListService {

    constructor(
        private http: HttpClient,
        private context: ParamContext
    ) {
    }

    search(params: any): Observable<HttpResponse<SampleList[]>> {
        const options = createRequestOption(params);

        return this.http.get<SampleList[]>(`${SERVER_API_URL}crops/${this.context.cropName}/sample-lists/search`, { params: options, observe: 'response' })
            .pipe(map((res: HttpResponse<SampleList[]>) => this.convertArrayResponse(res)));
    }

    download(listId: number, listName: string): Observable<HttpResponse<Blob>> {
        const options: HttpParams = new HttpParams()
            .append('programUUID', this.context.programUUID)
            .append('listName', listName);
        return this.http
            .get(`${SERVER_API_URL}crops/${this.context.cropName}/sample-lists/${listId}/download`, {
                params: options,
                responseType: 'blob',
                observe: 'response'
            });
    }

    importPlateInfo(listId: number, sampleList: any) {
        const options: HttpParams = new HttpParams()
            .append('programUUID', this.context.programUUID);
        return this.http.patch(`${SERVER_API_URL}crops/${this.context.cropName}/sample-lists/${listId}/samples`, sampleList, {
            params: options });
    }

    getSampleListsInStudy(studyId: number, withGenotypesOnly: boolean) {
        const url = `/bmsapi/crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/sample-lists?withGenotypesOnly=${withGenotypesOnly}`;
        return this.http.get<StudySampleList[]>(url, { observe: 'response' });
    };

    private convertArrayResponse(res: HttpResponse<SampleList[]>): HttpResponse<SampleList[]> {
        const jsonResponse: SampleList[] = res.body;
        const body: SampleList[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }
        return res.clone({ body });
    }

    /**
     * Convert a returned JSON object to SampleList.
     */
    private convertItemFromServer(sample: any): SampleList {
        const copy: SampleList = Object.assign({}, sample);
        return copy;
    }
}
